<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Configuración de costos</h1>
                <br>
                <v-alert :value="informacion" type="info" dismissible>
                    <h3>Valores requeridos</h3>
                    <br>
                    <span><b>SCRAP:</b> panel, densidad, nucleo, ubicacion</span>
                    <v-divider></v-divider>
                    <span><b>DIR Y IND:</b> panel, densidad, nucleo, ubicacion, espesor</span>
                    <v-divider></v-divider>
                    <span><b>IIBB + DYC BANCARIOS:</b> valor (porcentaje)</span>
                    <v-divider></v-divider>
                    <span><b>FACTORY MUTUAL:</b> nucleo, valor</span>
                    <v-divider></v-divider>
                    <span><b>SERVICIO DE MICROPERFORADO:</b> valor</span>
                </v-alert>
                <br>
                <v-alert :value="informacion" type="info" dismissible>
                    <h3>Estructura de archivo de excel para importación</h3>
                    <br>
                    <span><b>Orden de las columnas:</b></span>
                    <v-divider></v-divider>
                    <span>TIPO GASTO | UBICACION | TIPO PANEL | ESPESOR | DENSIDAD | NUCLEO | VALOR </span>
                    <br>
                    <span>Va a importar todo lo que se ingrese a partir de la fila 2</span>
                    <br>
                    <span>Si se encuentran errores en la importación, la misma no se realiza</span>
                </v-alert>
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-autocomplete clearable label="Tipo de costo" v-model="d.tipo" :items="tipos" @change="tabla()"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete multiple clearable label="Ubicación" v-model="d.ubicacion" :items="ubicaciones" @change="tabla()"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete multiple clearable label="Tipo panel" v-model="d.panel" :items="paneles" item-value="variable" item-text="desc" @change="tabla()"></v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-autocomplete multiple clearable label="Espesor" v-model="d.espesor" :items="espesores" item-value="variable" item-text="desc" @change="tabla()"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete multiple clearable label="Núcleo" v-model="d.nucleo" :items="nucleos" item-value="variable" item-text="desc" @change="tabla()"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete multiple clearable label="Densidad" v-model="d.densidad" :items="densidades" item-value="variable" item-text="desc" @change="tabla()"></v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-text-field clearable label="Valor" v-model="d.valor"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-btn @click.native="agregar" color="primary" :loading="loadingAdd">Agregar</v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-btn dark color="orange" @click="fileSel" :loading="importando">importar</v-btn>
                                <input type="file" style="display: none" ref="file" @change="fileProcess($event.target.files)"/>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-data-table
                                        :headers="headers"
                                        :items="items"
                                        :pagination.sync="pag"
                                        :total-items="totalItems"
                                        :loading="loading"
                                        rows-per-page-text="Filas por pagina"
                                        no-data-text="No hay datos"
                                        disable-initial-sort
                                        item-key="id"
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr @click="props.selected = !props.selected" @dblclick="props.expanded = !props.expanded">
                                            <td class="text-xs-center">{{ props.item.ubicacion | ubica }}</td>
                                            <td class="text-xs-center">{{ props.item.tipo }}</td>
                                            <td class="text-xs-center">{{ (props.item.panel)? props.item.panel.desc : '' }}</td>
                                            <td class="text-xs-center">{{ (props.item.nucleo)? props.item.nucleo.desc : '' }}</td>
                                            <td class="text-xs-center">{{ (props.item.espesor)? props.item.espesor.desc : '' }}</td>
                                            <td class="text-xs-center">{{ (props.item.densidad)? props.item.densidad.desc : '' }}</td>
                                            <td class="text-xs-right">{{ props.item.valor | moneda}}</td>
                                            <td class="text-xs-center">
                                                <v-btn flat icon @click.native="eliminar(props.item)" color="red" :loading="loadingDel === props.item.id">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';

    export default {
        name: "costo-config",
        filters: {
            moneda,
            ubica(value) {
                if (value === 'M') {
                    return 'MENDOZA';
                } else if (value === 'B') {
                    return 'BUENOS AIRES';
                } else {
                    return 'NO ASIGNADO';
                }
            }
        },
        data() {
            return {
                informacion: true,
                headers: [
                    {text: 'Ubiacación', value: 'ubicacion', align: 'center'},
                    {text: 'Tipo', value: 'tipo', align: 'center'},
                    {text: 'Panel', value: 'panel', align: 'center'},
                    {text: 'Núcleo', value: 'nucleo', align: 'center'},
                    {text: 'Espesor', value: 'espesor', align: 'center'},
                    {text: 'Densidad', value: 'densidad', align: 'center'},
                    {text: 'Valor', value: 'valor', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                tipos: [
                    {text: 'Mano de obra y gastos directos', value: 'DIR'},
                    {text: 'Mano de obra y gastos indirectos', value: 'IND'},
                    {text: 'Scrap', value: 'SCR'},
                    {text: 'IIBB + DYC BANCARIOS (%)', value: 'IIBB'},
                    {text: 'Factory mutual', value: 'FM'},
                    {text: 'Microperforado', value: 'MIC'},
                    {text: 'Gasto de sierras', value: 'SIE'},
                ],
                ubicaciones: [
                    {text: 'Mendoza', value: 'M'},
                    {text: 'Buenos Aires', value: 'B'},
                ],
                d: {
                    tipo: '',
                    espesor: [],
                    nucleo: [],
                    ubicacion: [],
                    valor: 0,
                    panel: [],
                    densidad: [],
                },
                loading: false,
                loadingAdd: false,
                importando: false,
                loadingDel: -1,
                pag: {},
                totalItems: 0,
                espesores: [],
                nucleos: [],
                items: [],
                paneles: [],
                densidades: [],
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            this.datos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.$http.post('indicadores/costo/config/datos')
                    .then(r => {
                        this.espesores = r.data.espesores;
                        this.nucleos = r.data.nucleos;
                        this.paneles = r.data.paneles;
                        this.densidades = r.data.densidades;
                    })
            },
            tabla() {
                this.loading = true;
                this.pag.filtros = this.d;
                this.$http.get('indicadores/costo/config/tabla?page=' + this.pag.page, {params: this.pag})
                    .then(r => {
                        this.totalItems = r.data.total;
                        this.items = r.data.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err)
                        this.loading = false;
                    })
            },
            agregar() {
                this.loadingAdd = true;
                this.$http.post('indicadores/costo/config/agregar', this.d)
                    .then(r => {
                        this.msj = r.data;
                        this.tabla();
                        this.loadingAdd = false;
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                        console.log(err);
                        this.loadingAdd = false;
                    })
            },
            eliminar(item) {
                this.loadingDel = item.id;
                this.$http.post('indicadores/costo/config/eliminar', item)
                    .then(r => {
                        this.msj = r.data;
                        this.tabla();
                        this.loadingDel = -1;
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                        console.log(err);
                        this.loadingDel = -1;
                    })
            },
            fileSel() {
                this.$refs.file.click();
            },
            fileProcess(fileList) {
                let fd = new FormData();
                fd.append('file', fileList[0]);
                this.importando = true;

                this.$http.post('indicadores/costo/config/importar', fd, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(r => {
                        this.msjShow(r.data);
                        this.importando = false;
                        this.$refs.file.value = '';
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al importar', tipo: 2});
                        this.importando = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/costo-config-precio.vue